import { Component, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { InsertPurityRequestModel } from 'src/app/components/administration/administration.model';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { IconHover } from '../../../enum/common-enum';

@Component({
  selector: 'app-purity-popup',
  templateUrl: './purity-popup.component.html',
  styleUrls: ['./purity-popup.component.scss']
})
export class PurityPopupComponent extends CommonService{
  insertPurityRequestModel = new InsertPurityRequestModel();
  @ViewChild("PurityForm") CategoryForm!: NgForm;
  currentHoverEffect = IconHover.Pink;

  constructor(public activeModal: NgbActiveModal,
    public administrationService    : AdministrationService,
    public renderer                 : Renderer2,
    public toaster                  : ToastrService,) {
      super(renderer)
    }

    InserCategoryList() {
      if (this.CategoryForm.valid) {
        this.administrationService.insertPurity(this.insertPurityRequestModel)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if (res.isSuccess) {
              this.toaster.success(res.message);
              this.activeModal.close(true);
            } else {
              this.toaster.error(res.message);
            }
          });
      }
    }
}
